import React from "react";
import { Download, ExternalLink, FileText } from "lucide-react";

const documents = [
  {
    title: "Datenblatt · Xortec Kameramast",
    desc: "Vollständige Broschüre mit allen Mastvarianten, Maßen und Zubehör.",
    href: "/xortec-kameramast-broschure.pdf",
    external: false,
    tag: "PDF · Broschüre",
    testId: "doc-mast",
  },
  {
    title: "Datenblatt · Xortec Anschlusskasten 165",
    desc: "Technische Daten der Mastbox 165 mm Edelstahl inkl. Ausstattungsvarianten.",
    href: "/xortec-anschlusskasten-datenblatt.pdf",
    external: false,
    tag: "PDF · Datenblatt",
    testId: "doc-box-165",
  },
  {
    title: "Datenblatt · Xortec Anschlusskasten 250",
    desc: "Technische Daten der Mastbox 250 mm Edelstahl inkl. Ausstattungsvarianten.",
    href: "/xortec-anschlusskasten-250-datenblatt.pdf",
    external: false,
    tag: "PDF · Datenblatt",
    testId: "doc-box-250",
  },
  {
    title: "Datenblatt · barox LT-LPITE-402GBTME Switch",
    desc: "Managed PoE-Switch von barox – offizielles Herstellerdokument.",
    href: "https://products.barox.ch/?pdf=lt-lpite-402gbtme",
    external: true,
    tag: "PDF · Hersteller",
    testId: "doc-switch",
  },
  {
    title: "Fundamentskizze · Kameramast Erdstück",
    desc: "Maßzeichnung für die Fundamentierung mit Erdstück-Variante.",
    href: "/xortec-fundament-erdstueck.pdf",
    external: false,
    tag: "PDF · Skizze",
    testId: "doc-fundament-erdstueck",
  },
  {
    title: "Fundamentskizze · Kameramast mit Fußplatte",
    desc: "Maßzeichnung und Ankerplan für die Fußplatten-Variante.",
    href: "/xortec-fundament-fussplatte.pdf",
    external: false,
    tag: "PDF · Skizze",
    testId: "doc-fundament-fussplatte",
  },
];

export default function Documents() {
  return (
    <section
      id="dokumente"
      data-testid="documents-section"
      className="relative bg-slate-50 py-24 md:py-32"
    >
      <div className="absolute inset-0 bg-grid opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-[#0055A4] mb-6">
            Dokumente
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight">
            Alle Datenblätter <span className="text-slate-500">auf einen Klick.</span>
          </h2>
          <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
            Technische Unterlagen für Ausschreibung, Planung und Montage – frei
            zum Download.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {documents.map((d) => (
            <a
              key={d.title}
              href={d.href}
              {...(d.external
                ? { target: "_blank", rel: "noreferrer" }
                : { download: true })}
              data-testid={d.testId}
              className="group relative flex flex-col rounded-xl border border-slate-200 bg-white p-6 hover:border-[#0055A4] hover:shadow-lg transition-all"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-[#0055A4]/10 text-[#0055A4] group-hover:bg-[#0055A4] group-hover:text-white transition-colors">
                  <FileText className="h-5 w-5" />
                </span>
                <span className="font-mono-tech text-[10px] uppercase tracking-widest text-slate-400">
                  {d.tag}
                </span>
              </div>
              <h3 className="font-display font-medium text-base text-slate-900 leading-snug">
                {d.title}
              </h3>
              <p className="mt-2 text-slate-600 text-xs leading-relaxed">
                {d.desc}
              </p>
              <div className="mt-5 pt-5 border-t border-slate-100 flex items-center justify-between text-sm font-medium text-[#0055A4]">
                <span>{d.external ? "Öffnen" : "Herunterladen"}</span>
                {d.external ? (
                  <ExternalLink className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                ) : (
                  <Download className="h-4 w-4 group-hover:translate-y-0.5 transition-transform" />
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
